import { useI18n } from 'builder/hooks/useI18n'

import AttachIcon from '../Icons/Attach.svg'
import { DocumentUploadProps } from './types'
import { TRANSLATION } from './constants'

import {
  DocumentsLineButton,
  DocumentsLineHead,
  DocumentsLineImg,
  DocumentsLineTitle,
} from './styles'

export const DocumentUpload = ({
  docType,
  refInput,
  handleUploadDocument,
  handleUploadDocumentButton,
}: DocumentUploadProps) => {
  const { i18n } = useI18n()

  const onOpenUploadDocument = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    handleUploadDocumentButton(e, docType)
  }

  return (
    <DocumentsLineHead>
      <DocumentsLineTitle>
        {i18n.t(`${TRANSLATION}.documents_titles.${docType}`)}
      </DocumentsLineTitle>
      <form>
        <input
          type="file"
          onChange={e => handleUploadDocument(e, docType)}
          ref={refInput}
          style={{ display: 'none' }}
        />
        <DocumentsLineButton onClick={onOpenUploadDocument}>
          <DocumentsLineImg src={AttachIcon} />
        </DocumentsLineButton>
      </form>
    </DocumentsLineHead>
  )
}
